import { createFileRoute, Link } from "@tanstack/react-router";

import logo from "@/assets/thevibingco_logo.svg.asset.json";

export const Route = createFileRoute("/checkout/return")({
  validateSearch: (search: Record<string, unknown>) => ({
    thread: typeof search.thread === "string" ? search.thread : undefined,
    session_id: typeof search.session_id === "string" ? search.session_id : undefined,
  }),
  head: () => ({
    meta: [
      { title: "Checkout complete · the Vibing Company®" },
      { name: "description", content: "Your payment went through. We'll be in touch shortly." },
      { property: "og:title", content: "Checkout complete · the Vibing Company®" },
      { property: "og:description", content: "Your payment went through. We'll be in touch shortly." },
      { name: "robots", content: "noindex" },
    ],
  }),
  component: CheckoutReturn,
});

function CheckoutReturn() {
  return (
    <main
      id="main"
      tabIndex={-1}
      className="min-h-[100dvh] flex flex-col items-center justify-center text-center px-6"
      style={{ background: "#fafbff" }}
    >
      <Link to="/" className="mb-12">
        <img src={logo.url} alt="the Vibing Company®" width={120} height={20} loading="lazy" decoding="async" className="h-5 w-auto" />
      </Link>
      <p className="font-mono text-[10px] tracking-[0.2em] uppercase text-muted-foreground">
        Payment confirmed
      </p>
      <h1 className="mt-4 font-display text-4xl md:text-6xl tracking-tight max-w-2xl leading-[1.05]">
        We're on it.
      </h1>
      <p className="mt-6 text-foreground/70 text-lg max-w-md leading-snug">
        Your payment went through and a receipt is on its way to your inbox. Expect a kickoff email from us within one working day.
      </p>
      <div className="mt-10 flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="inline-flex items-center justify-center rounded-full bg-foreground px-5 py-2.5 text-sm font-medium text-background hover:opacity-90 transition"
        >
          Back home
        </Link>
        <Link
          to="/dashboard"
          search={{ checkout: "success" }}
          className="inline-flex items-center justify-center rounded-full border border-foreground/15 px-5 py-2.5 text-sm font-medium text-foreground hover:bg-foreground/5 transition"
        >
          Go to dashboard
        </Link>
      </div>
    </main>
  );
}
